// Components
// Types
import { hourMinuteToSecond, secondToHourMinute } from 'utils/timeConverter';
import { TEInput } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
// Styles
import './TimeRange.scss';

interface ITimeRangeProps {
  label?: string;
  tooltip?: string;
  flow?: 'row' | 'column';
  value: ITimeRangeValue;
  onChange: (value: ITimeRangeValue) => void;
  disabled?: boolean;
}

type ITimeRangeValue = [number | null, number | null] | null;

const TimeRange = ({
  label,
  tooltip,
  flow = 'row',
  value,
  onChange,
  disabled,
}: ITimeRangeProps) => {
  const timeRangePicker = (
    <Space>
      <TEInput.HoursMinuteInput
        value={secondToHourMinute(value?.[0] || 0)}
        onChange={(val) => onChange([hourMinuteToSecond(val), value?.[1]])}
        disabled={disabled}
      />
      <>=&gt;</>
      <TEInput.HoursMinuteInput
        value={secondToHourMinute(value?.[1] || 0)}
        onChange={(val) => onChange([value?.[0], hourMinuteToSecond(val)])}
        disabled={disabled}
      />
    </Space>
  );
  return (
    <div className="te-time-range">
      {label ? (
        <TEInput.LabelWrapper label={label} tooltip={tooltip} flow={flow}>
          {timeRangePicker}
        </TEInput.LabelWrapper>
      ) : (
        timeRangePicker
      )}
    </div>
  );
};

export default TimeRange;
